import { Component } from '@angular/core';
import { DynControlBase } from '../dyn-controls-base';

@Component({
  selector: 'app-dyn-button',
  templateUrl: './dyn-button.component.html',
  styleUrls: ['./dyn-button.component.scss', '../dyn-controls.scss']
})
export class DynButtonComponent extends DynControlBase {
}
